export default __webpack_public_path__ + "static/sentimentRecognition-d59b43e0ca2d81920585cfa8a44228cd.png";